import { useState } from "react";
import { InstallDialog, isIOS, isStandalone } from "@/components/InstallDialog";
import { Smartphone, X } from "lucide-react";

const KEY = "install_banner_dismissed";

export function InstallBanner() {
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (hidden || !mobile || isStandalone()) return null;
  const dismiss = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <div data-testid="install-banner" className="fixed left-3 right-3 bottom-20 z-40 glass border border-[#F59E0B]/30 rounded-2xl px-4 py-3 flex items-center gap-3 shadow-lg">
      <Smartphone size={18} className="text-[#F59E0B] shrink-0" />
      <div className="min-w-0 flex-1 text-xs text-[#D1D5DB]">
        <span className="font-semibold text-[#F9FAFB]">Get the app on your {isIOS() ? "iPhone" : "phone"}</span> — add it to your Home Screen.
      </div>
      <InstallDialog trigger={
        <button data-testid="install-banner-button" className="shrink-0 px-3 py-1.5 rounded-full bg-[#F59E0B] text-black text-xs font-bold">How</button>
      } />
      <button data-testid="install-banner-dismiss" onClick={dismiss} aria-label="Dismiss" className="shrink-0 text-[#6B7280] hover:text-white"><X size={16} /></button>
    </div>
  );
}
